// Preserve authored translations; automatically fill only absent dictionary values.
export function withAutomaticFallback(strings, dictionaries, store, notify = () => {}) {
  const requested = new Set();
  const at = (object, path) => path.reduce((value, key) => value?.[key], object);
  store.subscribe(keys => { if (keys.some(key => requested.has(key))) notify(); });
  const wrap = (object, path = []) => new Proxy(object || {}, {
    get(target, key) {
      const value = Reflect.get(target, key);
      if (typeof key !== "string") return value;
      if (typeof value === "function") return value.bind(strings);
      const keys = [...path, key], language = strings.getLanguage();
      const selected = at(dictionaries[language], keys);
      const source = at(dictionaries.eng, keys) || at(dictionaries.tr, keys);
      if ((value && typeof value === "object") || (source && typeof source === "object")) return wrap(value, keys);
      if (typeof selected === "string" && selected.trim()) return value;
      if (!["eng", "arb"].includes(language) || typeof source !== "string" || !source.trim()) return value;
      const to = language === "arb" ? "ar" : "en";
      requested.add(store.keyFor(source, to));
      store.request(source, to);
      return store.read(source, to);
    }
  });
  return wrap(strings);
}
